import { render, staticRenderFns } from "./PersonStatisitics.vue?vue&type=template&id=51a15d1f&scoped=true"
import script from "./PersonStatisitics.vue?vue&type=script&lang=js"
export * from "./PersonStatisitics.vue?vue&type=script&lang=js"
import style0 from "./PersonStatisitics.vue?vue&type=style&index=0&id=51a15d1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a15d1f",
  null
  
)

export default component.exports